import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{#if this.playingTest}}\n  Playing...\n{{else}}\n  Play test sound\n{{/if}}\n",{ moduleName: "frontend/components/test-sound.hbs" })